import React, { Component } from "react";
import qs from "qs";
import { Col, CardBody, Row } from "reactstrap";
import MuIModal from '@material-ui/core/Modal';
import { withApollo } from 'react-apollo';
// import TotalProducts from './components/TotalProducts';
// import TotalProfit from './components/TotalProfit';
// import OrdersToday from './components/OrdersToday';
// import Subscriptions from './components/Subscriptions';
// import TopSellingProducts from './components/TopSellingProducts';
// import BasicCard from './components/BasicCard';
// import SalesStatistic from './components/SalesStatistic';
// import RecentOrders from './components/RecentOrders';
// import ProductSales from './components/ProductSales';
// import NewOrders from './components/NewOrders';
// import SalesStatistisBar from './components/SalesStatistisBar';
// import MyTodos from './components/MyTodos';
// import Emails from './components/Emails';
// import SalesReport from './components/SalesReport';
// import ShortReminders from './components/ShortReminders';
// import TrialAlert from '../../../components/alerts/components/BorderedAlertsWithIcons';
// import moment from 'moment';
// import { trialExpiresOn} from '../../../utils/mockData';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// import { NewReg } from './components/Steps';
// import MissingProfile from '../../NoProfile'
// import GetAssignedControls from './components/AssignedControls'
// import AssignedControls from './components/AssignedControls';
import Statistics from "../../compliance/components/Statistics";
import Modal from "../posture-dash/components/FrameworkModal";
import ComplianceToggleForm from "../posture-dash/components/ComplianceToggleForm";
import { signout } from "../../../redux/actions/userActions";
import { loadEnabledFrameworks } from "../../../redux/actions/complianceActions";
import { setReload } from "../../../redux/actions/apolloActions";
import { Link } from "react-router-dom";
import DataLoader from "../../../app/DataLoader";
import CompanyProfile from "../../onboarding/components/CompanyProfile";
import '../../../scss/component/onboarding/company_profile.scss'

// var start = moment(Date.now());
// var end = moment(new Date(trialExpiresOn));

class ECommerceDashboard extends Component {

  constructor (props) {
    super(props)
    this.state = {
      showTrialAlert: true,
      open: false,
      companyProfile: undefined,
      startOnboarding: true
    };
    // Bind event handlers and methods
    this.handleClose = this._handleClose.bind(this)
  }


  componentWillMount() {
    return this.props.user ? null : this.props.history.push("/unauthorized");
  }

  componentDidMount() {
    const values = qs.parse(this.props.location.search.slice(1));

    if (this.props.dataLoaded && values.mf && values.mf === "open") {
      this.setState({ open: true });
    }

    /*(async () => {
      try {
        this._isMounted = true;

        const { data: companyProfile } = await this.props.client.query({
          query: GetCompanyProfile(),
          fetchPolicy: 'network-only',
        })
        

        if (companyProfile && this._isMounted) {
          console.log(companyProfile);
          this.setState({companyProfile:companyProfile.getCompanyProfile})
          //this.previousCompanyProfileData = Object.assign({}, companyProfile)
          //console.log(this.previousCompanyProfileData);
        }

      } catch (e) {
        if (e.networkError) {
          if (e.networkError['statusCode'] === 401) {
            this.signoutUser()
          }
        } else {
          console.log(e.message)
          this.signoutUser()
        }
      }
    })().catch(error => {
      console.log(error)
    })*/

  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps || this.state.open !== nextState.open
      ? true
      : false;
  }

  closeAlert() {
    this.setState({ showTrialAlert: false });
  }

  modalBody() {
    return <ComplianceToggleForm />;
  }

  emptyDashboardCard() {
    return (
      <div>
        <Col
          className="card project-summary__statistics"
          style={{ float: "left" }}
        >
          <CardBody className="no-frameworks-selected">
            <p className="no-frameworks-body"> No frameworks selected </p>
          </CardBody>
        </Col>
        <div>
          <Col
            md={7}
            className=" card project-summary__statistics"
            style={{ float: "left" }}
          >
            <CardBody className="dashboard-card">
              <div className="project-summary__statistic_quick">
                <h5 className="project-summary__statistic-title">Quick Menu</h5>
                {/* <hr /> */}
                {this.props.enabledFrameworks &&
                this.props.enabledFrameworks.length > 0
                  ? this.props.enabledFrameworks.map(f => {
                      return (
                        <Link
                          className="primary-dashboard-link"
                          key={f.name}
                          to={`/app/compliance/${f.path}`}
                        >
                          <h4>{f.humanName} Controls</h4>
                        </Link>
                      );
                    })
                  : null}
                <Link className="primary-dashboard-link" to="/app/training">
                  <h4>Training</h4>
                </Link>
                {/* <Link className="primary-dashboard-link" to='/app/user/profile'><h4>Settings</h4></Link> */}
                <Link className="primary-dashboard-link" to="/logout">
                  <h4>Logout</h4>
                </Link>
              </div>
            </CardBody>
          </Col>
        </div>
      </div>
    );
  }

  signoutUser() {
    this.props.signout();
    this.props.history.push("/");
  }

  _handleClose = () => {
    this.setState({startOnboarding:false});
  };

  render() {
    let companyProfileModal;
    if(this.props.user && this.props.user["cognito:groups"] && this.props.user["cognito:groups"].includes("PostureAdmin")){
      if(this.props.companyProfile === null){
        companyProfileModal = (<MuIModal
        open={true}
        onClose={this.handleClose}
        >
          <div id="companyProfileModal">
            <CompanyProfile prev={this.props.companyProfile}/>
          </div>
        </MuIModal>)
      }
      else if(this.props.companyProfile !== undefined && this.props.companyProfile !== null){
        if(this.props.companyProfile.currentStep !== 2){
          companyProfileModal = (<MuIModal
            open={true}
            onClose={this.handleClose}
            >
              <div id="companyProfileModal">
                <CompanyProfile prev={this.props.companyProfile}/>
              </div>
            </MuIModal>)       
        }
        else{
          companyProfileModal = null
        }
      }
    }
    return (
      <DataLoader>
        <div className="dashboard">
          <Row>
            {
              <div style={{ width: "100%" }}>
                {!this.props.dataLoaded && (
                  <div
                    className={`custom_load load${
                      this.props.dataLoaded ? "" : " loaded"
                    }`}
                  >
                    <div className="load__icon-wrap">
                      <svg className="load__icon">
                        <path
                          fill="#2d9aa6"
                          d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                        />
                      </svg>
                    </div>
                  </div>
                )}
                <div>
                  <h3 className="page-title">
                    {this.props.compliance} Dashboard
                  </h3>
                  <h3 className="page-subhead subhead">
                    Gain a high-level view of your organization's compliance activity. 
                  </h3>
                  {companyProfileModal}
                  {["dev", "development", "qa", "demo", "prod", undefined].includes(
                    process.env.REACT_APP_ENV
                  ) && this.props.user['cognito:groups'] &&
                  this.props.user['cognito:groups'].find(e => {if(e === 'PostureAdmin'){ return true } if(e==='ComplianceManager'){ return true}}) && (
                    <React.Fragment>
                      <button
                        style={{ marginRight: "0" }}
                        className={`dashboard btn btn-primary add-compliance`}
                        onClick={() => {
                          this.setState({
                            open: !this.state.open
                          });
                        }}
                      >
                        Manage Frameworks
                      </button>

                      <Modal
                        modal={this.state.open}
                        toggle={() => {
                          this.setState({ open: !this.state.open });
                        }}
                        color="primary"
                        title="Available Frameworks"
                        name="Choose frameworks"
                        message={this.modalBody()}
                      />
                    </React.Fragment>
                  )}
                  {this.props.enabledFrameworks &&
                  this.props.enabledFrameworks.length === 0 ? (
                    this.emptyDashboardCard()
                  ) : this.props.dataLoaded ? (
                    <Statistics />
                  ) : null}
                </div>
              </div>
            }
          </Row>
        </div>
      </DataLoader>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    companyProfile: state.auth.companyProfile,
    // frameworks: state.controlsData.frameworks,
    enabledFrameworks: state.controlsData.enabledFrameworks,
    // summary: state.controlsData.summary,
    dataLoaded: !state.controlsData.loading,
    sidebar: state.sidebar
  };
}

export default connect(mapStateToProps, {
  signout,
  setReload,
  loadEnabledFrameworks
})(withRouter(withApollo(ECommerceDashboard)));



// WEBPACK FOOTER //
// ./src/components/dashboards/posture-dash/dashboard.js